// src/components/GlobalLoader.jsx
import React, { useEffect, useState } from "react";
import "./GlobalLoader.css"; // style as needed

const GlobalLoader = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleLoaderStateChange = (e) => {
      setLoading(e.detail.isLoading);
    };

    window.addEventListener("loaderStateChange", handleLoaderStateChange);
    return () => window.removeEventListener("loaderStateChange", handleLoaderStateChange);
  }, []);

  if (!loading) return null;

  return (
<div className="global-loader-overlay">
  <div className="global-loader-card">
    <div className="global_loader"></div>

    <div className="global-loader-text">
      {/* Good to see you again! Initializing your dashboard...<br /> */}
     <h2 style={{color:"black"}}>Welcome to HIM Companion Suite. </h2>
     Hang tight, getting things ready...
    </div>
  </div>
</div>
  );
};

export default GlobalLoader;
